import { render, staticRenderFns } from "./DatabaseEvents.vue?vue&type=template&id=639a4804&"
import script from "./DatabaseEvents.vue?vue&type=script&lang=js&"
export * from "./DatabaseEvents.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseEvents.vue?vue&type=style&index=0&id=639a4804&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports